import { Outlet } from "react-router-dom";

const InnerContent = () => {
  return (
    <>
      <div className="inner-content main-wrapper">
        <Outlet />
      </div>
      <div className="sidebar-overlay"></div>
    </>
  );
};

export default InnerContent;
